import { MOBILE_SCREEN_WIDTH } from '@common/constants';
import { useMediaQuery } from 'react-responsive';

export const useIsMobile = () => {
  return useMediaQuery({ maxWidth: MOBILE_SCREEN_WIDTH });
};
